<template>
  <div class="button_div"><a href="javascript:" @click="$emit('click')">{{ title }}</a></div>
</template>

<script>
export default {
  name: "GrayButton",
  emits: ['click'],
  props: ['title'],
  data() {
    return {
    }
  },
}
</script>

<style scoped>
.button_div {
  height: 40px;
}

.button_div a {
  width: 100%;
  height: 100%;
  background-color: #B1B1B1;
  color: white;
  text-align: center;
  align-content: center;
  font-size: 16px;
  border-radius: 10px;
}

.button_div a:hover {
  background-color: #333;
}
</style>